<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const title = computed(() => String(route.meta.title ?? "功能模块"));
const description = computed(() => String(route.meta.description ?? "该模块已纳入一体化工作台规划，真实业务接口尚待接入。"));
const phase = computed(() => String(route.meta.phase ?? "待接入"));
</script>

<template>
  <div class="module-preview">
    <div class="module-preview-copy">
      <span class="preview-label">MODULE PREVIEW</span>
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
      <div class="preview-status"><span></span>{{ phase }}</div>
    </div>
    <div class="module-blueprint">
      <div class="blueprint-toolbar"><i></i><i></i><i></i><span></span></div>
      <div class="blueprint-filter"><b></b><b></b><b></b></div>
      <div class="blueprint-table">
        <span v-for="n in 15" :key="n" :class="{ wide: n % 5 === 2 }"></span>
      </div>
      <strong>等待真实业务数据与接口联调</strong>
    </div>
  </div>
  <div class="notice honest-notice">此页面只展示规划位置，不生成模拟业务数据。完成接口核实后，将在这里提供筛选、列表、详情抽屉和权限控制。</div>
</template>

